import fazenda from './fazenda'

export default {
  fazenda,
}
